// client/src/api/submit.js
export async function submitAnalysis({ name, surname, email, phone, age, file }) {
  const form = new FormData();
  if (name) form.append("name", name);
  if (surname) form.append("surname", surname);
  if (email) form.append("email", email);
  if (phone) form.append("phone", phone);
  if (age) form.append("age", age);
  if (file) form.append("image", file);

  // prilagodi ako ti je putanja drugačija (npr. "/submit")
  const res = await fetch("/api/submit", { method: "POST", body: form });

  let data;
  try {
    data = await res.json();
  } catch {
    data = { status: "error", error: "Bad JSON" };
  }
  return data;
}
